<template>
  <CContainer class="d-flex align-items-center min-vh-100">
    <CRow class="w-100 justify-content-center">
      <CCol col="12" xs="11" sm="11" md="10" lg="8" xl="6">
        <div class="w-100">
        <div class="clearfix">
          <h1 class="float-left display-3 mr-4">401</h1>
          <h4 class="pt-3">Unauthorized</h4>
          <p class="text-muted">Anda tidak memiliki otorisasi untuk mengakses halaman ini.</p>
        </div>
      </div>
      </CCol>
    </CRow>
  </CContainer>
</template>
<script>
export default {
  name: 'Page401',
  data() {
    return{
    }
  }
}
</script>

